const GRAPHQL_TOKEN = window.storefront.token;
const GRAPHQL_URL   = window.storefront.url;
const GRAPHQL_BODY  = (body) => {
    return {
        'async': true,
        'crossDomain': true,
        'method': 'POST',
        'headers': {
        'X-Shopify-Storefront-Access-Token': GRAPHQL_TOKEN,
        'Content-Type': 'application/graphql',
        },
        'body': body
    };
};

const GET_PRODUCTS_BATCH_QUERY = (ids) => `
    {
        nodes(ids: [${ids.map(id => `"gid://shopify/ProductVariant/${id}"`).join(",")}]) {
            ... on ProductVariant {
                id
                product {
                    handle
                }
            }
        }
    }
`;
